var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlackClose = function SvgBlackClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.744 7.543 5.45 5.45c.043.087.087.175.087.263a.336.336 0 0 1-.088.22l-1.01 1.01c-.088.088-.176.088-.264.088-.088 0-.176 0-.22-.088L7.25 9.037l-5.45 5.45c-.087.087-.175.087-.263.087-.088 0-.176 0-.22-.088l-1.01-1.01c-.088-.044-.088-.132-.088-.22s0-.176.088-.264l5.449-5.449-5.45-5.45C.22 2.05.22 1.963.22 1.875s0-.176.088-.264L1.317.6a.336.336 0 0 1 .22-.088c.088 0 .176.044.264.088L7.25 6.049 12.7.599a.336.336 0 0 1 .219-.087c.088 0 .176.044.264.088l1.01 1.01c.044.088.088.176.088.264a.336.336 0 0 1-.088.22l-.922.923-4.527 4.526Z",
    fill: "#000"
  })));
};

export default SvgBlackClose;